/*
 * Puente wishlist Yuxus <-> Swish (Wishlist King) — 2026-11-04
 *
 * Los corazones del tema (~70 ficheros) guardan los favoritos en localStorage('wishlist')
 * con forma {handle?, id?, url, title, image}. No se tocan: este puente
 *   1) intercepta localStorage.setItem/removeItem('wishlist') y replica en Swish lo que
 *      se añade o se quita (por handle), en cola y de uno en uno;
 *   2) al cargar, reconcilia con la lista de Swish del cliente/sesion actual:
 *        - la primera vez para una identidad (cliente o sesion de invitado) UNE las dos;
 *        - despues, lo que estaba sincronizado y ya no esta en un lado se borra del otro
 *          (borrado hecho en otro dispositivo o desde Swish).
 *      La memoria de "lo ya sincronizado" va por identidad, asi que cerrar sesion NO
 *      vacia los favoritos del navegador, e iniciar sesion vuelca los del invitado a la
 *      cuenta (eso es lo que hace "Guardar mi wishlist" del sorteo).
 * Swish lo crea su app embed "App settings" en window.WishlistKing. Si el embed no esta
 * activo, el puente no hace nada y la wishlist sigue funcionando como siempre (solo local).
 * Emite window 'yx:wishlist-change' {detail:{count}} cada vez que cambia la lista local.
 *
 * Variante (2026-11-05): el favorito local puede llevar `variantId` (la talla que eligio el
 * cliente en la PDP; ver snippets/yuxus-wishlist.liquid). Se envia en addWishlistItem y,
 * si cambia en un producto ya guardado, se actualiza con updateWishlistItem. Para saber en
 * que lado cambio se recuerda la ultima variante sincronizada por identidad. A los
 * favoritos sin variante no se les pone ninguna.
 */
(function () {
  'use strict';
  if (window.__yxSwishBridge) return;
  window.__yxSwishBridge = true;

  var KEY = 'wishlist';
  var SYNCED_KEY = 'yx_wl_swish_synced'; // { "<identidad>": ["handle", ...] }
  var DEBUG = /yxwl=debug/.test(location.search);
  function log() { if (DEBUG) console.log.apply(console, ['[yx-swish]'].concat([].slice.call(arguments))); }

  var ls;
  try { ls = window.localStorage; ls.getItem(KEY); } catch (e) { return; }

  // ---------- lista local ----------
  function handleOf(it) {
    if (!it) return '';
    if (it.handle) return String(it.handle).trim();
    var m = String(it.url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function readLocal() {
    try { var a = JSON.parse(ls.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function handleSet(arr) {
    var s = {};
    arr.forEach(function (it) { var h = handleOf(it); if (h) s[h] = true; });
    return s;
  }
  // id numerico de una variante (acepta numero, texto o GID)
  function vid(v) { var m = String(v == null ? '' : v).match(/(\d+)\s*$/); return m ? m[1] : ''; }
  function variantMap(arr) { // handle -> variantId ('' = sin talla)
    var m = {};
    arr.forEach(function (it) { var h = handleOf(it); if (h && !m[h]) m[h] = vid(it && it.variantId); });
    return m;
  }
  function emit() {
    var n = Object.keys(handleSet(readLocal())).length;
    try { window.dispatchEvent(new CustomEvent('yx:wishlist-change', { detail: { count: n } })); } catch (e) {}
  }

  var origSet = Storage.prototype.setItem;
  var origRemove = Storage.prototype.removeItem;
  var muted = false; // escrituras del propio puente: no replicar a Swish

  Storage.prototype.setItem = function (k, v) {
    var watch = this === ls && k === KEY;
    var before = watch ? variantMap(readLocal()) : null;
    var r = origSet.apply(this, arguments);
    if (watch) { if (!muted) diffToSwish(before, variantMap(readLocal())); emit(); }
    return r;
  };
  Storage.prototype.removeItem = function (k) {
    var watch = this === ls && k === KEY;
    var before = watch ? variantMap(readLocal()) : null;
    var r = origRemove.apply(this, arguments);
    if (watch) { if (!muted) diffToSwish(before, {}); emit(); }
    return r;
  };
  function writeLocal(arr) {
    muted = true;
    try { origSet.call(ls, KEY, JSON.stringify(arr)); } finally { muted = false; }
    emit();
  }

  // ---------- memoria de sincronizado (por identidad) ----------
  function identity() {
    if (!app) return '';
    if (app.customer && app.customer.id) return 'c:' + app.customer.id;
    var sid = '';
    try { sid = app.getSessionId ? (app.getSessionId() || '') : ''; } catch (e) {}
    return 's:' + (sid || 'none');
  }
  function readSyncedAll() { try { return JSON.parse(ls.getItem(SYNCED_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function readSynced() {
    var all = readSyncedAll(), list = all[identity()] || [], s = {};
    list.forEach(function (h) { s[h] = true; });
    return s;
  }
  function writeSynced(set) {
    var all = readSyncedAll();
    all[identity()] = Object.keys(set);
    // invitado sin sesion aun -> al crear Swish la sesion cambia la identidad; se copia
    try { origSet.call(ls, SYNCED_KEY, JSON.stringify(all)); } catch (e) {}
  }
  function markSynced(h, on) {
    var s = readSynced();
    if (on) s[h] = true; else delete s[h];
    writeSynced(s);
  }
  var SYNCED_V_KEY = 'yx_wl_swish_synced_v'; // { "<identidad>": { handle: variantId } }
  function readSyncedVAll() { try { return JSON.parse(ls.getItem(SYNCED_V_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function readSyncedV() { return readSyncedVAll()[identity()] || {}; }
  function setSyncedV(h, v) {
    var all = readSyncedVAll(), cur = all[identity()] || {};
    if (v) cur[h] = v; else delete cur[h];
    all[identity()] = cur;
    try { origSet.call(ls, SYNCED_V_KEY, JSON.stringify(all)); } catch (e) {}
  }

  // ---------- Swish ----------
  var app = null;
  var current = null; // ultima lista de Swish {items:[{id, product:{handle,id,title,...}}]}
  var waiters = [];
  var queue = Promise.resolve();

  function swishMap() { // handle -> [itemId, ...]
    var m = {};
    ((current && current.items) || []).forEach(function (it) {
      var h = it && it.product && it.product.handle;
      if (!h) return;
      (m[h] = m[h] || []).push(it.id);
    });
    return m;
  }
  function swishVariantOf(it) {
    if (!it) return '';
    return vid(it.variantId || (it.variant && (it.variant.id || it.variant.variantId)) || '');
  }
  function swishVMap() { // handle -> {id: itemId, v: variantId} (el primero)
    var m = {};
    ((current && current.items) || []).forEach(function (it) {
      var h = it && it.product && it.product.handle;
      if (!h || m[h]) return;
      m[h] = { id: it.id, v: swishVariantOf(it) };
    });
    return m;
  }
  function onWishlist(w) {
    current = w;
    var ws = waiters.splice(0);
    ws.forEach(function (f) { f(); });
  }
  function nextUpdate(ms) {
    return new Promise(function (res) {
      var done = false;
      function fin() { if (!done) { done = true; res(); } }
      waiters.push(fin);
      setTimeout(fin, ms || 5000);
    });
  }
  function enqueue(fn) {
    queue = queue.then(fn).catch(function (e) { console.warn('[yx-swish]', e && e.message ? e.message : e); });
    return queue;
  }
  function swishAdd(h, v) {
    return enqueue(function () {
      if (swishMap()[h]) { markSynced(h, true); if (v) return doUpdate(h, v); return; }
      var wait = nextUpdate();
      var payload = { productHandle: h };
      if (v) payload.variantId = Number(v);
      log('add', h, v || '(sin talla)');
      return Promise.resolve(app.state.addWishlistItem(payload)).then(function () { return wait; })
        .then(function () { if (swishMap()[h]) { markSynced(h, true); setSyncedV(h, v || ''); } });
    });
  }
  function doUpdate(h, v) {
    var cur = swishVMap()[h];
    if (!cur || !v) return;
    if (cur.v === v) { setSyncedV(h, v); return; }
    if (!app.state.updateWishlistItem) { log('sin updateWishlistItem'); return; }
    var wait = nextUpdate();
    log('update', h, cur.v || '(sin talla)', '->', v);
    return Promise.resolve(app.state.updateWishlistItem({ wishlistItemId: cur.id, changes: { variantId: Number(v) } }))
      .then(function () { return wait; }).then(function () { setSyncedV(h, v); });
  }
  function swishUpdate(h, v) { return enqueue(function () { return doUpdate(h, v); }); }
  function swishRemove(h) {
    return enqueue(function () {
      var ids = swishMap()[h] || [];
      if (!ids.length) { markSynced(h, false); return; }
      log('remove', h, ids);
      return ids.reduce(function (p, id) {
        return p.then(function () {
          var wait = nextUpdate();
          return Promise.resolve(app.state.removeWishlistItem({ wishlistItemId: id })).then(function () { return wait; });
        });
      }, Promise.resolve()).then(function () { markSynced(h, false); setSyncedV(h, ''); });
    });
  }
  function diffToSwish(before, after) { // mapas handle -> variantId
    if (!app || !ready) return; // antes de la reconciliacion inicial: lo recoge reconcile()
    Object.keys(after).forEach(function (h) {
      if (!(h in before)) swishAdd(h, after[h]);
      else if (after[h] && after[h] !== before[h]) swishUpdate(h, after[h]);
    });
    Object.keys(before).forEach(function (h) { if (!(h in after)) swishRemove(h); });
  }

  var ready = false;
  function reconcile() {
    var local = readLocal();
    var L = handleSet(local), S = swishMap(), P = readSynced();
    var addSwish = [], removeSwish = [], addLocal = [], removeLocal = {};
    Object.keys(L).forEach(function (h) {
      if (S[h]) return;
      if (P[h]) removeLocal[h] = true; else addSwish.push(h);
    });
    Object.keys(S).forEach(function (h) {
      if (L[h]) return;
      if (P[h]) removeSwish.push(h); else addLocal.push(h);
    });
    log('reconcile', { local: Object.keys(L), swish: Object.keys(S), synced: Object.keys(P), addSwish: addSwish, removeSwish: removeSwish, addLocal: addLocal, removeLocal: Object.keys(removeLocal) });

    if (addLocal.length || Object.keys(removeLocal).length) {
      var next = local.filter(function (it) { return !removeLocal[handleOf(it)]; });
      ((current && current.items) || []).forEach(function (it) {
        var p = it.product || {};
        if (addLocal.indexOf(p.handle) < 0 || handleSet(next)[p.handle]) return;
        var img = (p.featuredImage && (p.featuredImage.url || p.featuredImage.src)) || (p.images && p.images[0] && (p.images[0].url || p.images[0].src || p.images[0])) || p.image || '';
        var row = { id: p.id ? String(p.id).replace(/\D/g, '') : '', handle: p.handle, url: '/products/' + p.handle, title: p.title || '', image: typeof img === 'string' ? img : '' };
        var nv = swishVariantOf(it);
        if (nv) row.variantId = nv;
        next.push(row);
      });
      writeLocal(next);
    }
    // lo que ya coincide queda marcado como sincronizado
    var both = {};
    Object.keys(handleSet(readLocal())).forEach(function (h) { if (S[h]) both[h] = true; });
    writeSynced(both);

    // Variantes de lo que esta en los dos lados. Gana el lado que cambio desde la ultima
    // sincronizacion; si nunca se sincronizo, gana el que tenga talla (local si ambos).
    var LV = variantMap(readLocal()), SV = swishVMap(), PV = readSyncedV();
    var pullV = {}, pushV = [];
    Object.keys(both).forEach(function (h) {
      var lv = LV[h] || '', sv = (SV[h] && SV[h].v) || '', pv = PV[h] || '';
      if (lv === sv) { setSyncedV(h, lv); return; }
      if (!lv) { pullV[h] = sv; return; }
      if (!sv) { pushV.push([h, lv]); return; }
      if (lv === pv) pullV[h] = sv; else pushV.push([h, lv]);
    });
    if (Object.keys(pullV).length) {
      writeLocal(readLocal().map(function (it) { var h = handleOf(it); if (it && pullV.hasOwnProperty(h)) it.variantId = pullV[h]; return it; }));
      Object.keys(pullV).forEach(function (h) { setSyncedV(h, pullV[h]); });
    }
    log('variantes', { pull: pullV, push: pushV });

    ready = true;
    var LVnow = variantMap(readLocal());
    addSwish.forEach(function (h) { swishAdd(h, LVnow[h] || ''); });
    removeSwish.forEach(swishRemove);
    pushV.forEach(function (x) { swishUpdate(x[0], x[1]); });
  }

  function getApp() {
    return new Promise(function (res) {
      if (window.WishlistKing) return res(window.WishlistKing);
      var tries = 0;
      var t = setInterval(function () {
        if (window.WishlistKing) { clearInterval(t); res(window.WishlistKing); }
        else if (++tries > 100) { clearInterval(t); res(null); } // 20 s sin Swish: solo local
      }, 200);
    });
  }

  function start() {
    if (!window.WishlistKingAppLoaderURL && !window.WishlistKing) { log('Swish no activo: solo local'); emit(); return; }
    getApp().then(function (a) {
      if (!a || !a.state || !a.state.observeWishlist) { log('Swish sin app'); return; }
      app = a;
      var first = true;
      app.state.observeWishlist({ wishlistId: 'mine' }).subscribe(function (w) {
        onWishlist(w);
        if (first) { first = false; reconcile(); }
      });
    });
  }

  // API minima para la pagina del sorteo
  window.YX_WISHLIST = {
    count: function () { return Object.keys(handleSet(readLocal())).length; },
    handles: function () { return Object.keys(handleSet(readLocal())); },
    swishReady: function () { return !!(app && ready); },
    swishCount: function () { return Object.keys(swishMap()).length; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
